import { createStore, compose, applyMiddleware } from 'redux'
import { devToolsEnhancer } from 'redux-devtools-extension/developmentOnly'
import { routerMiddleware } from 'connected-react-router'
import createSagaMiddleware from 'redux-saga'
import { loadUser } from 'redux-oidc'
import { createBrowserHistory } from 'history'
import createRootReducer from './reducers'
import rootSaga from './sagas'
import userManager from '../utils/userManager'

export const history = createBrowserHistory()
const sagaMiddleware = createSagaMiddleware()

export default function configureStore() {
  const store = createStore(
    createRootReducer(history), // root reducer with router state
    //preloadState,
    compose(
      applyMiddleware(
        routerMiddleware(history), // for dispatching history actions
        sagaMiddleware
      ),
      devToolsEnhancer({})
    )
  )

  sagaMiddleware.run(rootSaga)

  loadUser(store, userManager)
  return store
}
